import { useTranslation } from 'react-i18next';
import { SERVICE_MODE } from '../../../../../constants/ServiceConstants';
import { IExceptionModel } from '../../../../../models';
import { getModeFromUrl } from '../../../../../utilities/services/ServiceListUtils';
import { ServiceExceptionForm } from '../exception-form/ServiceExceptionForm';
import { ServiceExceptionItem } from '../exception-form/exception-item/ServiceExceptionItem';
import classes from './ExceptionList.module.scss';

interface IExceptionList {
  exceptionList: IExceptionModel[] | null,
  continueHandler: (status: boolean) => void,
  isEditService: boolean
  localExceptionList: IExceptionModel[]
}
/**
 * Show the exception list
 */
export const ExceptionList = ({ exceptionList, continueHandler, isEditService, localExceptionList }: IExceptionList) => {
  const { t: translate } = useTranslation();
  const serviceMode = getModeFromUrl();
  const isEditOrCreateMode = serviceMode !== SERVICE_MODE.VIEW;
  return (
    <div>
      {
    isEditOrCreateMode ? (
      <>
        <ServiceExceptionForm
          isEditService={serviceMode !== SERVICE_MODE.VIEW}
          continueHandler={continueHandler}
        />

        <div>
          {localExceptionList?.length > 0 && (
            localExceptionList?.map(
              (exception: IExceptionModel) =>
                exception.exceptionId && (
                  <ServiceExceptionItem
                    exceptionId={exception.exceptionId}
                    action={exception.action}
                    errorCode={exception.errorCode}
                    key={exception.id}
                    isEditService={isEditService}
                    itemEdit={exception.isEdit}
                    id={exception.id}
                  />
                )
            )
          )}
          {serviceMode === SERVICE_MODE.EDIT && !localExceptionList?.length && (
            <div className={classes['no-exception-msg']}>
              {translate('view_edit_service_exceptions.no_exceptions_message')}
            </div>
          )}
        </div>
      </>
    ) : (
      <div>
        {exceptionList?.length ? (
          exceptionList?.map(
            (exception: IExceptionModel) =>
              exception.exceptionId && (
                <ServiceExceptionItem
                  exceptionId={exception.exceptionId}
                  action={exception.action}
                  errorCode={exception.errorCode}
                  key={exception.id}
                  isEditService={isEditService}
                  itemEdit={false}
                  id={exception.id}
                />
              )
          )
        ) : (
          <div className={classes['no-exception-msg']}>
            {translate('view_edit_service_exceptions.no_exceptions_message')}
          </div>
        )}
      </div>
    )
  }
    </div>
);
};
